export const DEFAULT_PAGE_NUMBER = 1;
export const QUOTES_PER_PAGE = 3;
export const PAGE_SIZE = 10;
export const DATA_TYPE = {
  number: 'number',
  string: 'string',
};
export enum PAGE {
  QUOTES = 'quotes',
  POLICIES = 'policies',
}
export enum TIA_CHANNELS {
  WEB = 'WEB',
  TIA = 'TIA',
  INTAG = 'INTAG',
}
